import * as repairSmallTicketApi from '../../api/repairSmallTicketApi'

const state = {
    repairSmallTicket: {},
    repairCertificate: {}
}

const actions = {
    //维修凭证（小票）
    async getRepairSmallTicket({ commit }, serviceOrderSysNo){
        const response = await repairSmallTicketApi.getRepairSmallTicket(serviceOrderSysNo);
        commit('setRepairSmallTicket', response);
		return response;
    },
    //接机单
    async getRepairCertificate({ commit }, serviceOrderSysNo){
        const response = await repairSmallTicketApi.getRepairCertificate(serviceOrderSysNo);
        commit('setRepairCertificate', response);
		return response;
    }
}

const mutations = {
    setRepairSmallTicket(state, res) {
        if (res && res.Status) { // 查询成功
            state.repairSmallTicket = res.Data;
		}
    },
    setRepairCertificate(state, res) {
        if (res && res.Status) { // 查询成功
            state.repairCertificate = res.Data;
		}
    }
}

export default {
	namespaced: true,
	state,
	actions,
	mutations
}


// WEBPACK FOOTER //
// ./src/store/modules/repairSmallTicket.js